import React, { Component } from 'react';
import { Icon, OutsideClickHandler } from 'b3';

export default class TimeDurationInput extends Component {
	state = {
		duration: 15,
		focussed: false
	};
	changeDuration = (e) => {
		this.setState({
			duration: e.target.value
		})
	}
	setFocused = () => {
		this.setState({focussed: true});
		this.input.select();
	}
	onClickOutside = () => {
		this.setState({focussed: false});
	}
	render() {

		var { duration, focussed } = this.state;
		return (
			<OutsideClickHandler onOutsideClick={focussed ? this.onClickOutside : () => {}}>
				<div onClick={this.setFocused} className={focussed ? "time-duration-input focussed" : "time-duration-input"}>
					<Icon icon="timer-1" size={18} />
					<input ref={el => this.input = el} type="number" onChange={this.changeDuration} value={duration} />
					<span>mins</span>
				</div>
			</OutsideClickHandler>
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/TimeDurationInput.js